<template>
  <div>
    <!-- <div class="old_site">
    Добро пожаловать на бета-версию сайта
    <ui-button
      @click="old"
      :loading="loadingOld"
      :disabled="loadingOld"
      class="btn btn-base btn-small"
      >Старая версия</ui-button
    >
  </div> -->
    <header class="header">
      <router-link to="/" class="header-logo">
        <Logo class="login-inner__logo" />
      </router-link>

      <div class="header-inner">
        <div class="d-xl-none ms-auto d-flex align-items-center">
          <div class="menu-bar js-menu-bar" @click="openMenu">
            <span class="menu-bar__stick"></span>
            <span class="menu-bar__stick"></span
            ><span class="menu-bar__stick"></span>
          </div>
        </div>
        <div class="header-alert">
          <!-- ICON -->
          <div class="d-flex align-items-center h-100">
            <RouterLink
              to="/notifications"
              class="btn-header-bell"
              title="Уведомления"
            >
              <BellIcon class="header-icon" />
              <span
                v-if="getNotificationTotal && getNotificationTotal !== 0"
                class="badge bg-warning btn-header-notification-badge"
                >+{{ getNotificationTotal }}</span
              >
            </RouterLink>
          </div>
        </div>
        <div class="header-lk h-100">
          <div class="d-flex align-items-center h-100">
            <div class="header-profile h-100 ms-auto">
              <div class="row h-100 g-0 flex-nowrap">
                <div
                  class="col h-100 d-flex align-items-center"
                  style="min-width: 0"
                >
                  <div class="px-3 text-truncate text-center fw-medium w-100">
                    {{ getCompanies.find((i) => i.id === companyId)?.company }}
                  </div>
                </div>

                <div v-if="getCompanies?.length > 1" class="col-auto">
                  <div
                    @click="modalCO"
                    class="btn-header-exit"
                    title="Сменить профиль"
                  >
                    <SwapIcon class="header-icon" />
                  </div>
                </div>

                <div class="col-auto">
                  <div @click="logout" class="btn-header-exit" title="Выйти">
                    <ExitIcon class="header-icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <ui-modal v-if="modal" :close="modalCO">
      <div class="modal-header">
        <h5 class="modal-title">Сменить профиль</h5>
        <button class="btn-close" type="button" @click="modalCO"></button>
      </div>
      <div class="modal-body">
        <div class="header-company">
          <div
            v-for="item in getCompanies"
            :key="item.id"
            class="header-company-item text-truncate"
            @click="() => company(item.id)"
          >
            {{ item.company }}
          </div>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
import { postApi } from "@/run";

import Logo from "@/assets/svg/Logo.vue";

import SwapIcon from "@/assets/svg/swap.vue";
import ExitIcon from "@/assets/svg/exit.vue";

import BellIcon from "@/assets/svg/bell.vue";

import axios from "axios";

import "./style.css";

import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => {
    return {
      companyId: null,
      loadingOld: false,
      modal: false,
    };
  },
  components: {
    Logo,
    ExitIcon,
    SwapIcon,
    BellIcon,
  },
  computed: {
    ...mapGetters({
      getCompanies: "main/getCompanies",
      getCompanyId: "main/getCompanyId",
      getNotificationTotal: "main/getNotificationTotal",
    }),
  },
  methods: {
    ...mapMutations({
      setLoading: "main/setLoading",
      setData: "main/setData",
      setRoot: "main/setRoot",
      setNewUser: "main/setNewUser",
      setContracts: "page/setContracts",
      setNotifications: "page/setNotifications",
    }),
    modalCO() {
      this.modal = !this.modal;
    },
    company(id) {
      this.setLoading(true);
      postApi("/changeCompany", {
        company: id,
      }).then((res) => {
        if (res.status) {
          this.setContracts([]);
          this.setNotifications([]);
          this.setData(res.root);
          this.setRoot(true);
          this.$router.push("/");
        }

        this.setLoading(false);
      });
    },
    lockBodyScroll() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.dataset.scrollY = String(scrollY);
    },
    unlockBodyScroll() {
      const scrollY = parseInt(document.body.dataset.scrollY || "0", 10);
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";

      // отключаем плавность только для этого вызова
      const html = document.documentElement;
      html.style.scrollBehavior = "auto";
      window.scrollTo(0, scrollY);
      html.style.scrollBehavior = "";

      document.body.removeAttribute("data-scroll-y");
      window.scrollTo(0, scrollY);
    },
    openMenu() {
      const body = document.body;
      const isOpen = body.classList.contains("mobile-menu-open");

      if (!isOpen) {
        body.classList.add("mobile-menu-open");
        this.lockBodyScroll(); // страница зафиксирована, меню видно сверху
      } else {
        body.classList.remove("mobile-menu-open");
        this.unlockBodyScroll();
      }

      const sidebar = document.querySelector(".sidebar");
      if (sidebar) {
        sidebar.scrollTop = 0; // сразу к верху
      }
    },
    logout() {
      this.setLoading(true);
      postApi("/logout", {}).then((res) => {
        if (res.status) {
          this.setRoot(false);
          this.setNewUser(false);
        }
        this.setLoading(false);
      });
    },
    old() {
      this.loadingOld = true;

      axios
        .post("//dev.asket.ru/api/old", {
          id: this.companyId,
        })
        .then((response) => {
          if (response.data.error) {
            alert(response.data.error);
            this.loadingOld = false;
          } else {
            window.location.replace(
              "https://lk.stone-xxi.ru/login.php?UID=" + response.data.uid
            );
          }
        });
    },
  },
  created() {
    this.companyId = this.getCompanyId;
  },
};
</script>


<style>
.old_site {
  text-align: center;
  padding: 15px;
  background: #000;
  color: #fff;
}

/* .sidebar {
    top: 159px !important;
}

@media (min-width: 433px) {
    .sidebar {
        top: 138px !important;
    }
} */

/* @media (min-width: 768px) {} */

/* @media (min-width: 992px) {} */

/* @media (min-width: 1200px) {} */

/* @media (min-width: 1400px) {} */
</style>